import {API} from "@/Composables/api";

const getStimuli = async (params) => {
    return API.get(route("stimuli.index"), params);
};

const getStimulus = async (stimulus, params) => {
    return API.get(route("stimuli.show", stimulus), params);
};

const storeStimulus = async (stimulus, params = {}) => {
    return API.post(route("stimuli.store"), params, stimulus);
};

const updateStimulus = async (stimulus, data, params = {}) => {
    return API.post(route("stimuli.update", stimulus.id), params, data, "PUT");
};

const getOpengraphData = async (stimulus, params = {}) => {
    return API.get(route("og-data", stimulus), params, false);
};

const getOpengraphPreview = async (params = {}) => {
    return API.get(route("og-preview"), params, false);
};

const deleteStimulus = async (stimulus, params = {}) => {
    return API.delete(route("stimuli.destroy", stimulus), params);
};

export {getStimuli, getStimulus, storeStimulus, updateStimulus, getOpengraphData, getOpengraphPreview, deleteStimulus};
